import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-retro-bg flex items-center justify-center">
        <div className="retro-card p-8 text-center">
          <div className="w-16 h-16 mx-auto bg-retro-primary rounded-retro border-2 border-retro-line flex items-center justify-center shadow-retro-1 mb-4">
            <div className="w-8 h-8 border-3 border-black border-t-transparent rounded-full animate-spin"></div>
          </div>
          <h2 className="text-retro-pixel text-lg text-retro-primary mb-2">VERIFICANDO ACESSO...</h2>
          <p className="text-retro-muted text-sm">Aguarde um momento</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;